<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 29">
    <path fill="#000B1A" stroke="#6DAADD" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.9 6.4v0a9.2 9.2 0 0 1 0 13.3l-5.3 5v0c-.9.9-2.3.9-3.2 0l-5.3-5h0a9.2 9.2 0 0 1 0-13.3v0h0a10 10 0 0 1 13.8 0h0Z" />
    <path stroke="#6DAADD" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 16.2c1.8 0 3.3-1.4 3.3-3.2 0-1.8-1.5-3.2-3.3-3.2a3.3 3.3 0 0 0-3.3 3.2c0 1.8 1.5 3.2 3.3 3.2Z" />
  </svg>
</template>
